module.exports = __webpack_public_path__ + "img/border-3--active.a956dd2a.svg";